import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import { pluralize, pluralizeVerb } from "shared/Pluralize";

type VCSDeleteIntegrationModalProps = {
  attachedEntitiesQty: number;
  integrationName: string;
  linkPath?: string;
  onConfirm: () => void;
};

const VCSDeleteIntegrationModal = create(function VCSDeleteIntegrationModal({
  attachedEntitiesQty,
  integrationName,
  linkPath,
  onConfirm,
}: VCSDeleteIntegrationModalProps) {
  const modal = useModal();

  const handleConfirm = () => {
    onConfirm();
    modal.hide();
  };

  return (
    <DeleteConfirmationModal title="Delete integration" onConfirm={handleConfirm}>
      <ConfirmationModalMessage>
        Are you sure you want to delete <strong>{integrationName}</strong>?
      </ConfirmationModalMessage>

      {attachedEntitiesQty > 0 && (
        <>
          <br />
          <br />
          <Typography tag="p">
            <b>{attachedEntitiesQty}</b> {pluralize("stack", attachedEntitiesQty)}/
            {pluralize("module", attachedEntitiesQty)} still{" "}
            {pluralizeVerb("use", attachedEntitiesQty)} this integration.{" "}
            {linkPath && (
              <Link onPress={modal.hide} href={linkPath}>
                Go to "Used by" page
              </Link>
            )}
          </Typography>
        </>
      )}
    </DeleteConfirmationModal>
  );
});

export const showVCSDeleteIntegrationModal = (props: VCSDeleteIntegrationModalProps) =>
  show(VCSDeleteIntegrationModal, props);
